import React from 'react';
import './TextButton.scss';
export const TextButton = ({ disabled, onClick, children }) => {
    return (React.createElement("button", { className: "CSVImporter_TextButton", disabled: disabled, onClick: onClick }, children));
};
